module.exports = __webpack_public_path__ + "static/media/scanopro-3.d3f262c4.jpg";